<template>
    <add-edit-preventativebarrier></add-edit-preventativebarrier>
</template>

<script>
import AddEditPreventativebarrier from "@/layouts/components/risk-management/preventative-barriers/addedit-preventativebarrier.vue";


export default {
 components : {
   AddEditPreventativebarrier
 },
};
</script>